<template>
  <div class="app-shell">
    <a class="skip-link" href="#main-content">{{ $t('accessibility.skipToContent') }}</a>
    <main id="main-content" class="app-shell__main" tabindex="-1">
      <slot />
    </main>
  </div>
</template>
